module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ;  var u = require('util/Util.js').default;
  steps = [1, 2, 5, 10]

    ; __append("\r\n<div class=\"propTitle prop-header hide\"><span class=\"prop-label\">Numeric Stepper Settings</span></div>\r\n<div class=\"nav-position prop-detail\" >\r\n    <div class=\"row\">\r\n        <div class=\"col-md-12 nopadding-r\">\r\n            <div> <input class=\"text\" type=\"text\" value=\"")
    ; __append(escapeFn(value))
    ; __append("\" name=\"value\" style=\"width:224px\" /></div>\r\n        </div>\r\n    </div>\r\n\r\n    <div class=\"row\">\r\n        <div class=\"col-md-6 subsection\">\r\n            <label class=\"prop-sublabel label-35\">Min</label> \r\n            <div>\r\n                <input type=\"text\" value=\"")
    ; __append(escapeFn( min ))
    ; __append("\" name=\"min\" class=\"label-65\" style=\"width:69px!important;\"/>\r\n            </div>\r\n        </div>\r\n       \r\n        <div class=\"col-md-6 subsection\">\r\n            <label class=\"prop-sublabel label-35\">Max</label> \r\n            <div>\r\n                <input type=\"text\" value=\"")
    ; __append(escapeFn( max ))
    ; __append("\" name=\"max\"class=\"label-65\"/>\r\n            </div>\r\n        </div>\r\n        \r\n    </div>\r\n\r\n    <div class=\"row\">\r\n        <div class=\"col-md-2 subsection nopadding-r\"> \r\n            <label class=\"prop-sublabel label-35\">Step</label> \r\n            <div>\r\n                <select name=\"stepSize\" id=\"stepSize\">\r\n                    ")
    ;  for (var i = 0; i < steps.length; i++) { 
    ; __append("\r\n                        <option value=\"")
    ; __append(escapeFn(steps[i] ))
    ; __append("\">")
    ; __append(escapeFn(steps[i]))
    ; __append("</option>\r\n                    ")
    ;  }; 
    ; __append("\r\n                </select>\r\n            </div> \r\n        </div>\r\n    </div>\r\n</div>")
  }
  return __output;

}